import { useState } from "react";
import Preloader from "../components/Preloader";
import PartsGrid from "../components/parts/PartsGrid";
import { useCallback } from "react";
import { Box, Button, Card, Dialog, TextField, useMediaQuery, useTheme } from "@mui/material";
import Translate from "../utils/Translate";
import SpeedMenu from "../components/SpeedMenu";
import AddIcon from "@mui/icons-material/Add";
import { accessKeys, hasAccess } from "../utils/userAccess";
import { ContentCopy, Search } from "@mui/icons-material";
import PartDialogForm from "../components/parts/PartDialogForm";
import CopySpecialPricesDialog from "../components/parts/CopySpecialPricesDialog";

export default function PartsPage(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [unsubmittedSearchText, setUnsubmittedSearchText] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [showCreatePartDialog, setShowCreatePartDialog] = useState(false);
  const [showCopySpecialPricesDialog, setShowCopySpecialPricesDialog] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const finishedLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const speedMenuActions = [
    {
      icon: <ContentCopy _ />,
      text: Translate.get("CopySpecialPrices"),
      onClick: () => setShowCopySpecialPricesDialog(true),
      hide: !hasAccess(accessKeys.licenseIssuer),
    },
    {
      icon: <AddIcon />,
      text: Translate.get("CreatePart"),
      onClick: () => setShowCreatePartDialog(true),
      hide: !hasAccess(accessKeys.isMASystem),
    },
  ];
  speedMenuActions.push();

  return (
    <>
      {isLoading && <Preloader />}
      {showCreatePartDialog && (
        <Dialog open className="partDialog" onClose={() => setShowCreatePartDialog(false)}>
          <PartDialogForm onClose={() => setShowCreatePartDialog(false)} />
        </Dialog>
      )}
      {showCopySpecialPricesDialog && <CopySpecialPricesDialog onClose={() => setShowCopySpecialPricesDialog(false)} />}
      <SpeedMenu content={speedMenuActions} />
      <div className="stdFlexRowTop">
        <h2>{Translate.get("PartsLabel")}</h2>
        <Box width="100%" marginLeft="8px">
          <form
            className="actorsSearchForm"
            onSubmit={(ev) => {
              ev.preventDefault();
              setSearchText(unsubmittedSearchText);
            }}
          >
            <TextField
              inputProps={{ spellCheck: false }}
              fullWidth
              id="outlined-basic"
              label={Translate.get("Search")}
              variant="outlined"
              value={unsubmittedSearchText ?? ""}
              onChange={(ev) => {
                setUnsubmittedSearchText(ev.target.value);
                if (!ev.target.value) {
                  // Normally we will only update the searchText on submit. But if the text
                  // is cleared it might be confusing to only see previous search results
                  setSearchText(null);
                }
              }}
            />
            {!isSmallScreen && (
              <Button type="submit" className="actorsSearchButton" variant="contained" endIcon={<Search />}>
                {Translate.get("Search")}
              </Button>
            )}
          </form>
        </Box>
      </div>
      <Card>
        <PartsGrid searchText={searchText} onLoaded={finishedLoading} />
      </Card>
    </>
  );
}
